/**
 * Дождаться ближайшей отрисовки кадра. Нужен перед тяжёлой синхронной работой (сборка файла выгрузки):
 * выставленное до неё состояние — ход на кнопке — успевает попасть на экран, а не появляется вместе
 * с результатом. Колбэк `requestAnimationFrame` идёт до отрисовки, таймер из него — уже после неё.
 * В скрытой вкладке кадров нет, и ждать их незачем — хватает таймера.
 */
export const nextPaint = (): Promise<void> =>
    new Promise((resolve) => {
        const afterTask = () => setTimeout(resolve, 0);
        if (typeof requestAnimationFrame !== 'function' || document.visibilityState === 'hidden') afterTask();
        else requestAnimationFrame(afterTask);
    });
